import { Injectable } from '@angular/core';
import { PostLocationModel } from '@app/core/models';
import { AddressesStep, BuildingType } from '@app/core/models/addresses.model';
import { BehaviorSubject } from 'rxjs';

/**
 * Service responsible for handling addresses-related functionality.
 */
@Injectable({
  providedIn: 'root',
})
export class AddressesService {
  currentStep$ = new BehaviorSubject<AddressesStep>(AddressesStep.MyAddresses);
  selectedPlace: PostLocationModel | null = null;
  selectedBuildingType: BuildingType = BuildingType.Apartment;

  constructor() {}

  public setCurrentStep(step: AddressesStep) {
    this.currentStep$.next(step);
  }

  public nextStep() {
    this.currentStep$.next(this.getNextStep());
  }

  public previousStep() {
    this.currentStep$.next(this.getPreviousStep());
  }

  private getNextStep(): AddressesStep {
    switch (this.currentStep$.getValue()) {
      case AddressesStep.PropertyType: {
        return AddressesStep.ConfirmAddress;
      }
      case AddressesStep.MyAddresses: {
        return AddressesStep.PropertyType;
      }
      case AddressesStep.ConfirmAddress: {
        return AddressesStep.MyAddresses;
      }
    }
  }

  private getPreviousStep(): AddressesStep {
    switch (this.currentStep$.getValue()) {
      case AddressesStep.ConfirmAddress: {
        return AddressesStep.PropertyType;
      }
      case AddressesStep.PropertyType: {
        return AddressesStep.MyAddresses;
      }
      case AddressesStep.MyAddresses: {
        return AddressesStep.MyAddresses;
      }
    }
  }

  public getCurrentStep() {
    return this.currentStep$.getValue();
  }

  public reset() {
    this.currentStep$.next(AddressesStep.MyAddresses);
    this.selectedPlace = null;
    this.selectedBuildingType = BuildingType.Apartment;
  }
}
